import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, Mail, Package, CalendarDays } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

const steps = [
  {
    icon: Mail,
    title: 'CONFIRMATION EMAIL',
    text: 'PayPal has emailed you a receipt. Keep it safe — it is your proof of purchase.',
  },
  {
    icon: Package,
    title: 'POSTED TO YOU',
    text: 'We hand-number your physical voucher and post it to the address on your PayPal order, usually within 2–3 working days.',
  },
  {
    icon: CalendarDays,
    title: 'REDEEM AT THE STUDIO',
    text: 'Bring the original voucher to the appointment. Valid for 12 months against any tattoo or laser removal treatment.',
  },
];

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black flex flex-col">
      <Navbar />

      <main className="flex-1 pt-32 pb-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <CheckCircle2 size={56} className="mx-auto text-white mb-6 animate-fade-in" data-testid="thankyou-icon" />
          <p className="text-white/50 text-xs tracking-[0.3em] mb-3">ORDER COMPLETE</p>
          <h1
            data-testid="thankyou-title"
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-widest leading-tight mb-5"
            style={{ fontFamily: "'Cinzel Decorative', serif" }}
          >
            THANK YOU
          </h1>
          <p className="text-white text-lg md:text-xl tracking-wider mb-4">Your voucher is on its way.</p>
          <p className="text-white/60 text-base max-w-xl mx-auto leading-relaxed">
            Thanks for supporting Atlantic Coast Tattoo. Here&apos;s what happens next.
          </p>
        </div>

        <div className="max-w-4xl mx-auto mt-16 grid sm:grid-cols-3 gap-6" data-testid="thankyou-steps">
          {steps.map(({ icon: Icon, title, text }, i) => (
            <div
              key={title}
              className="border border-white/15 bg-white/[0.03] p-6 text-left animate-fade-in"
              style={{ animationDelay: `${0.15 * (i + 1)}s` }}
            >
              <div className="flex items-center gap-3 mb-3 text-white">
                <span className="text-white/40 text-xs tracking-widest">0{i + 1}</span>
                <Icon size={20} />
              </div>
              <h3 className="text-sm font-bold tracking-widest text-white mb-2">{title}</h3>
              <p className="text-white/65 text-sm leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto mt-14 text-center space-y-4">
          <p className="text-white/60 text-sm">
            Questions about your order? Email{' '}
            <a href="mailto:studio@atlanticcoasttattoo.com" className="text-white underline underline-offset-4 hover:text-gray-300">
              studio@atlanticcoasttattoo.com
            </a>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2">
            <button
              data-testid="thankyou-home-btn"
              onClick={() => navigate('/')}
              className="bg-white text-black px-8 py-3 text-sm tracking-widest hover:bg-gray-200 transition-colors"
            >
              BACK TO HOME
            </button>
            <button
              data-testid="thankyou-shop-btn"
              onClick={() => navigate('/shop')}
              className="border border-white text-white px-8 py-3 text-sm tracking-widest hover:bg-white hover:text-black transition-colors"
            >
              BUY ANOTHER VOUCHER
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ThankYou;
